import React from 'react';
import SliderPartialRequestWithLabel from './SliderPartialRequestWithLabel';
import NumberedStepContainer from '../../EmployeeDashboard/Utils/NumberedStepContainer';
import { useTranslation } from 'react-i18next';

/**
 * @typedef {import('./SliderPartialRequest').SliderPartialRequestProps} SliderPartialRequestProps
 *
 */

/**
 *
 * @param {SliderPartialRequestProps & {
 *  classes: *;
 *  index: number;
 *  selectedPartial: string;
 *  employeeSchedule?: Array<{startDateTime: Date, endDateTime: Date}>;
 *  color?: string;
 *  managerSettingEntityId?: number;
 * }} param0
 */
const SliderPartialRequestWrapper = ({
    classes,
    storeData = {},
    shifts,
    handleChange,
    index,
    selectedPartial,
    onSelectionInvalid,
    requestType,
    employeeSchedule = [],
    color,
    managerSettingEntityId,
}) => {
    const { t } = useTranslation('employmentBillboard', { keyPrefix: 'billboard' });

    return (
        <NumberedStepContainer
            title={t('partialShiftOption')}
            stepNumber={index}
            classes={classes}
            isCollapsable
        >
            <SliderPartialRequestWithLabel
                shifts={shifts}
                storeData={storeData}
                requestType={requestType}
                handleChange={handleChange}
                onSelectionInvalid={onSelectionInvalid}
                selectedPartial={selectedPartial}
                employeeSchedule={employeeSchedule}
                color={color}
                managerSettingEntityId={managerSettingEntityId}
            />

        </NumberedStepContainer>
    );
}

export default SliderPartialRequestWrapper;
